var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSouthAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.348 8L0 2.652v10.695L5.348 8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M7.553 8L0 .44v2.213L5.348 8 0 13.348v2.212L7.553 8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M23.895 9.568S23.933 9.5 24 9.5V6.433H10.432L3.998-.003H0V.44L7.553 8 0 15.56v.443h3.998l6.434-6.435h13.463z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M23.587 11.128H11.085L6.21 16.003H24v-4.875h-.413z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M23.587 4.872H24V-.003H6.21l4.875 4.875h12.502z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfrica);
export default __webpack_public_path__ + "static/media/SouthAfrica.aa0867b517f8557cfad84b21144606a8.svg";
export { ForwardRef as ReactComponent };